import { useMutation } from '@tanstack/react-query';
import { api } from 'constants/api';
import { AudienceFiltersBrazeObject } from 'types/create-campaign';
import { ApiResponse } from 'types/utils/api-response';
import { MutationOptions } from 'types/utils/mutation-options';

type EstimationChannelResponse = {
  credit_cost: number;
  estimated_reachable_users: number;
  has_credits: boolean;
};

export type CampaignEstimationsResponseType = {
  sms: EstimationChannelResponse;
  push: EstimationChannelResponse;
};

type Params = {
  audience_filters: AudienceFiltersBrazeObject;
  store_ids?: number[];
  message_length?: number;
  message_encoding?: string;
  scheduled_time: number;
};

export const useEstimateAudience = (
  options: MutationOptions<CampaignEstimationsResponseType, Params>
) => {
  const mutation = useMutation({
    mutationFn: async (params) => {
      const { data } = await api.post<
        ApiResponse<CampaignEstimationsResponseType>
      >('/audience/estimate', params);

      return data.data;
    },
    ...options,
  });

  return {
    ...mutation,
    isLoading: mutation.isPending,
  };
};
